import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "password-input" }
const _hoisted_2 = { class: "password-input__container" }
const _hoisted_3 = ["type", "id", "placeholder", "autocomplete"]

import { computed, onMounted, ref, nextTick } from "vue";
import KasaIcon from "@/components/shared/assets/kasa-icon.vue";
import AccountInput from "./account-input.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'password-input',
  props: /*@__PURE__*/_mergeModels({
    modelValue: {},
    name: {},
    placeholder: {},
    autocompleteOff: { type: Boolean },
    showEyeIcon: { type: Boolean },
    focus: { type: Boolean }
  }, {
    "errorMessage": {},
    "errorMessageModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["update:modelValue", "inputKeyUp", "inputErrorDetected"], ["update:errorMessage"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;

const props = __props;

const errorMessage = _useModel<string>(__props, "errorMessage");

const passwordValue = computed({
    get() {
        return props.modelValue;
    },
    set(passwordValue) {
        errorMessage.value = null;
        emit("update:modelValue", passwordValue);
    },
});

const eyeActive = ref(false);
const showPassword = async () => {
    eyeActive.value = !eyeActive.value;
};

const inputType = computed(() => (eyeActive.value ? "text" : "password"));

const inputKeyUp = (event: KeyboardEvent) => {
    emit("inputKeyUp", event);
};

const checkIfIsValid = (silentCheck?: boolean): boolean => {
    let isValid = true;

    if (!passwordValue.value) {
        if (!silentCheck) {
            errorMessage.value = "Zadejte prosím svoje heslo.";
        }
        isValid = false;
    }

    nextTick(() => {
        if (errorMessage.value) emit("inputErrorDetected", props.name, errorMessage.value);
    });

    return isValid;
};

const inputRef = ref<HTMLInputElement>(null);
onMounted(() => {
    console.log("focus", props.focus);
    if (props.focus) {
        inputRef.value.focus();
    }
});

__expose({
    checkIfIsValid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AccountInput, {
      errorMessage: errorMessage.value,
      name: _ctx.name,
      onInputErrorDetected: _cache[1] || (_cache[1] = ($event: any) => (emit('inputErrorDetected', _ctx.name, errorMessage.value)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: inputType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((passwordValue).value = $event)),
            id: _ctx.name,
            placeholder: _ctx.placeholder ?? 'Heslo',
            autocomplete: _ctx.autocompleteOff ? 'off' : null,
            ref_key: "inputRef",
            ref: inputRef,
            onKeyup: inputKeyUp
          }, null, 40, _hoisted_3), [
            [_vModelDynamic, passwordValue.value]
          ]),
          (_ctx.showEyeIcon)
            ? (_openBlock(), _createBlock(KasaIcon, {
                key: 0,
                name: "eye",
                width: 20,
                height: 20,
                class: "password-input__input-icon",
                onClick: showPassword
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["errorMessage", "name"])
  ]))
}
}

})